import profileimg from '../../assets/images/profileimg.png'
import dummyprofile from '../../assets/images/dummyprofile.png'
import Button from 'antd/es/button';
import Card from 'antd/es/card';
import TransactionInfo from './TransactionInfo';

const CustomerInfo = ({ transactionList, custInfo, handleOpenModal, setUpdateModal, setAddBonusModal, setOpenModal, userId, onScroll, listInnerRef }) => {
  return (
    <>
      <div className="customerdetails d-flex mt-3">
        <div className="profileinfo ">

          <div className="profileinfoone d-flex">
            <div className="profilenameemailimg d-flex" >
              <div className="profileimg">
                <img src={custInfo.userData.profilePicture ? custInfo.userData.profilePicture : dummyprofile} style={{ width: "100%", height: '100%', borderRadius: "50%" }} />
              </div>
              <div className="profilenameandemail">
                <div className="profilename" style={{ color: "#003B5B", fontWeight: "600" }}>{custInfo.userData.fullName}</div>
                <div className="profilemail" style={{ color: "#111111", fontSize: "19px", fontWeight: "400" }}>{custInfo.userData.email}</div>
              </div>
            </div>
            <div>
              <div className="profilebtns d-flex"></div>
              <Button className="profileupdatebtn" onClick={() => { setUpdateModal(true) }}>Update Details</Button>
              <Button className="profilebonusbtn" onClick={() => { setAddBonusModal(true) }}>Add Bonus</Button>
            </div>
          </div>
          <hr style={{ width: "98%" }} /><div className="profileinfotwo">
            <div className="profileinfod1 d-flex">
              <div className="profilebal">Total Available Balance:</div>
              <div className="profileamount1">${custInfo.amount}</div>
            </div>
            <div className="profileinfod1 d-flex">
              <div className="profilebal">Total Retail Purchase:</div>
              <div className="profileamount2">${custInfo.retailAmount}</div>
            </div>
            <div className="profileinfod1 d-flex">
              <div className="profilebal">Total BNKD Amount Used:</div>
              <div className="profileamount3" style={{ color: "red" }}>${custInfo.usedAmount}</div>
            </div>
          </div>
          <hr style={{ width: "98%" }} />
          <div className="subscribedpackage">
            <div className="subscribedpac">Subscribed Packages</div>
            <div className="packageinfo">
              <div className="packagename">Package Name</div>
              <div className="packagestatus">Status</div>
            </div>
          </div>
          <hr style={{ width: "98%", marginTop: "0rem" }} />
          <div className="businesssub">
            {custInfo.membershipData.map((item) => {
              return (
                <div className="businnesnamestatus">
                  <div className="businessname">{item?.title}</div>
                  <div className={item.hasCanceled=='0'?new Date() > new Date(item.pauseTill) && new Date() < new Date(item.subscriptionEnd) ? "status active" : "status":"status"}>
                    <span />
                    {item.hasCanceled=='0'?(new Date() > new Date(item.pauseTill) && new Date() <= new Date(item.subscriptionEnd)) ? "Active" : "InActive":"InActive"}
                  </div>
                </div>
              )
            })}
          </div>
          <div className="paymentbtns d-flex">
            <Button className="pausemembership" onClick={() => { handleOpenModal() }}>Pause Membership</Button>
            <Button className="paymentbtn" onClick={() => { setOpenModal(true) }}>Make Payment</Button>
          </div>
        </div>
        <div className={userId ? "transactionsinfo" : "custtransactionsinfo"}>
          <Card >
            <div className="transactionsheader">Recent Transactions</div>
            <div className="transactioninfo" style={{ width: "100%", overflow: "scroll" }} ref={listInnerRef} onScroll={onScroll}>
              {transactionList?.map((item) => {
                return (
                  <>
                    <TransactionInfo item={item} />
                    <hr />
                  </>
                )
              })}
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default CustomerInfo